<template>
  <div class="container" style="max-width: 900px;"  v-if="['N'].find(el=>el==store.state.user.groupe)">
    <div  >
        <div>
            <div style="text-align: center;">
                <img src="https://www.edisac.com/images/photolib_la/Header-com_mb.jpg" alt="" />
            </div>
        </div>
        
        <div v-if="dataresponse&&dataresponse.reception&&dataresponse.statut=='accepted'">
            <div v-if="dataresponse&&dataresponse.statut=='accepted'&&dataresponse.reception.language.match(/FR/gmi)" style="font-family: Arial, Helvetica, sans-serif; font-size: 1rem;">                                 
                <p>Bonjour {{dataresponse.reception.prenom}},</p>
                <p>Nous sommes ravis que notre offre vous ait convaincu !</p>
                <p>Vous allez bientôt recevoir un e-mail contenant votre bon d’achat, valable dans tous nos magasins pendant 6 mois.</p>
                <p>Votre article va désormais être reconditionné avec soin par notre équipe, puis remis en vente afin de lui offrir une seconde vie.</p>
                <p><b>L’équipe EDISAC</b></p><br/>
                <p>Retrouvez nos conditions générales d’utilisation <a href='https://www.edisac.com/second-life-cgv-t16037/'>ici</a></p>
            </div>
            <div v-if="dataresponse&&dataresponse.statut=='accepted'&&dataresponse.reception.language.match(/NL/gmi)" style="font-family: Arial, Helvetica, sans-serif; font-size: 1rem;">                             
                <p>Beste {{dataresponse.reception.prenom}},</p>
                <p>We zijn verheugd dat onze aanbieding u heeft overtuigd!</p>
                <p>U ontvangt binnenkort een e-mail met daarin uw waardebon, geldig in al onze winkels gedurende 6 maanden.</p>
                <p>Uw artikel wordt nu zorgvuldig gereconditioneerd door ons team en vervolgens weer te koop aangeboden om het een tweede leven te geven.</p>
                <p><b>Het EDISAC-team</b></p><br/>
                <p>Onze algemene voorwaarden vindt u <a href='https://www.edisac.com/second-life-cgv-t16037/'>hier</a></p>
            </div>
        </div>
        
        <div v-if="dataresponse&&dataresponse.reception&&dataresponse.statut=='refused'">
            <div v-if="dataresponse&&dataresponse.statut=='refused'&&dataresponse.reception.language.match(/FR/gmi)" style="font-family: Arial, Helvetica, sans-serif; font-size: 1rem;">                                
                <p>Bonjour {{ dataresponse.reception.prenom }},</p>
                <p>Nous sommes navrés que notre proposition n’ait pas retenu votre attention.</p>
                <p>Pas de souci, nous respectons totalement votre choix !</p>
                <p>Selon l’option que vous avez sélectionnée lors du dépôt de votre article, celui-ci sera soit renvoyé en magasin pour vous être restitué, soit donné à notre association partenaire pour une seconde vie.</p>
                <p><b>L’équipe EDISAC</b></p><br/>
                <p>Retrouvez nos conditions générales d’utilisation <a href='https://www.edisac.com/second-life-cgv-t16037/'>ici</a></p>
            </div>
            <div v-if="dataresponse&&dataresponse.statut=='refused'&&dataresponse.reception.language.match(/NL/gmi)" style="font-family: Arial, Helvetica, sans-serif; font-size: 1rem;">                                
                <p>Beste {{ dataresponse.reception.prenom }},</p>
                <p>We betreuren dat ons voorstel uw aandacht niet heeft getrokken.</p>
                <p>Geen probleem, we respecteren uw keuze volledig!</p>
                <p>Afhankelijk van de optie die u heeft geselecteerd bij het inleveren van uw artikel, zal dit artikel ofwel teruggestuurd worden naar de winkel om aan u terug te geven, ofwel geschonken worden aan onze partnervereniging voor een tweede leven.</p>
                <p><b>Het EDISAC-team</b></p><br/>
                <p>Onze algemene voorwaarden vindt u <a href='https://www.edisac.com/second-life-cgv-t16037/'>hier</a></p>
            </div>
        
        </div>
        <div v-if="dataresponse&&dataresponse.reception&&dataresponse.statut=='getted'">
            <div v-if="dataresponse&&dataresponse.statut=='getted'&&dataresponse.reception.language.match(/FR/gmi)" style="font-family: Arial, Helvetica, sans-serif; font-size: 1rem;">                            
                <p>Bonjour {{dataresponse.reception.prenom}},</p>
                <p>Nous avons déjà eu votre réponse</p>
                <p>Veuillez consulter vos emails, sinon contactez L’équipe EDISAC</p>
                
                <p><b>L’équipe EDISAC</b></p><br/>
                <p>Retrouvez nos conditions générales d’utilisation <a href='https://www.edisac.com/second-life-cgv-t16037/'>ici</a></p>
            </div>
            <div v-if="dataresponse&&dataresponse.statut=='getted'&&dataresponse.reception.language.match(/NL/gmi)" style="font-family: Arial, Helvetica, sans-serif; font-size: 1rem;">                            
                <p>Beste {{dataresponse.reception.prenom}},</p>
                <p>We hebben uw antwoord al ontvangen</p>
                <p>Raadpleeg uw e-mails, neem anders contact op met Het EDISAC-team</p>
                
                <p><b>Het EDISAC-team</b></p><br/>
                <p>Onze algemene voorwaarden vindt u <a href='https://www.edisac.com/second-life-cgv-t16037/'>hier</a></p>
            </div>
            
        </div>

            
    </div>
    <img style="width: 100%;height: 10px; object-fit: cover; display: block; " src="https://www.edisac.com/images/photolib_la/footer2.jpg" alt="" />
  </div>
</template>
<script setup>
    import { ref,  onMounted} from 'vue'
    import { useRoute, onBeforeRouteUpdate } from 'vue-router'
    const route = useRoute()
    import store from '@/store'
    import router from '@/router'
    import axios from 'axios'
    let dataresponse=ref()
    const getResponse = async (donnes) => {
        const url = `https://my.edisac.com/api/restoken`
        try {
            const config = {
            method: 'post',
            url: url,
            data: donnes
            }
            const response = await axios.request(config)
            
            if (response.data.exist) {
                dataresponse.value=response.data
            } else{
                router.replace({ path: '/login' })
            }
        } catch (error) {
            router.replace({ path: '/login' })
            console.error('Erreur lors du chargement des données:', error)
        } 
    }

    let currentUrl=ref()
    const loadParams = () => {
        if (route.query.res!=null && route.query.token) {
            try {
                currentUrl.value = window.location.href
                store.commit('addUser', { groupe: 'N' })
                getResponse({...route.query,ip:store.state.ip})
            } catch (err) {
                router.replace({ path: '/login' })
            
            }
        } else {
            router.replace({ path: '/login' })
        }
    }
    onBeforeRouteUpdate(() => {
        loadParams()
    })

    onMounted(() => {
        loadParams()
    })

</script>